<script setup lang="ts">
import { computed } from 'vue';
import { toBool } from '../../../utils/CommonFunctions';


const props = defineProps<{
  modelValue: boolean | null | string | number | undefined
  type?: string
  label: string
  error?: string | null
  readonly?: boolean
  placeholder?: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'change', value: boolean): void
  (e: 'blur'): void
}>()

import { CSSProperties } from 'vue';

const computedStyle = computed((): CSSProperties => {
  return {
    pointerEvents: props.readonly ? 'none' : '' as CSSProperties['pointerEvents'],
  };
});

const handleChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const value = target.checked;
  emit('change', value);
  emit('update:modelValue', value);
  emit('blur');
};
</script>

<template>
  <div>
    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">
      {{ label }}
    </label>
    <div class="mt-1">
        <input
            type="checkbox"
            :style="computedStyle"
            :checked="toBool(modelValue)"
            @change="handleChange"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded cursor-pointer"
        :class="[
          error
            ? 'border-red-300 dark:border-red-700'
            : 'border-gray-300 dark:border-gray-600'
        ]"
        />
    </div>
    <p v-if="error" class="mt-1 text-sm text-red-600 dark:text-red-400">{{ error }}</p>
  </div>
</template>